// extracted by mini-css-extract-plugin
export default {"InputContainer":"InputContainer_InputContainer__tIcbf","IsViewingStream":"InputContainer_IsViewingStream__FsZd-"};